// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bc09de33","455":"43cf5e3c","977":"3c04667c"}[chunkId] + ".chunk.js";
};